import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams, useHistory } from 'react-router-dom';
import OrderDetailsMobile from './OrderDetailsMobile';
import OrderDetailsDesktop from './OrderDetailsDesktop';
import Header from '../../Header';
import Footer from '../../Footer';

const OrderDetailsPage = () => {
  const { orderId } = useParams();
  const history = useHistory();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const token = localStorage.getItem('token');
    if (!token) {
      history.push('/login');
      return;
    }

    axios
      .get(`/api/v1/user/order/${orderId}`, {
        headers: {
          Authorization: token
        }
      })
      .then(res => {
        setOrder(res.data.data);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [orderId, history]);

  if (loading) {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col p-0'>
            <Header />
          </div>
        </div>
        <div className='container py-5 text-center'>
          Завантаження…
        </div>
        <div className='row'>
          <div className='col p-0'>
            <Footer />
          </div>
        </div>
      </div>
    );
  }

  if (error || !order) {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col p-0'>
            <Header />
          </div>
        </div>
        <div className='container py-5 text-center'>
          <h5>Не вдалося знайти замовлення</h5>
          <Link to='/user/personal-cabinet' className='btn btn-dark mt-3'>
            Повернутися до замовлень
          </Link>
        </div>
        <div className='row'>
          <div className='col p-0'>
            <Footer />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='container'>
        <div className='row'>
          <div className='col p-0'>
            <Header />
          </div>
        </div>

        {/* ===== MOBILE ===== */}
        <div className='row d-lg-none'>
          <div className='col p-0'>
            <OrderDetailsMobile order={order} />
          </div>
        </div>

        {/* ===== DESKTOP ===== */}
        <div className='row d-none d-lg-block'>
          <div className='col p-0'>
            <OrderDetailsDesktop order={order} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OrderDetailsPage;